"use strict";
export const INTERFACE_NAV_HEIGHT = 72;
